"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseTranslation = require("nicbase-translation");

require("./footer.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SelectionModeFooter = function SelectionModeFooter(_ref) {
  var onSelectMode = _ref.onSelectMode,
      activeMode = _ref.activeMode,
      modes = _ref.modes;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex border-t border-b border-gray-200"
  }, Object.keys(modes).map(function (mode) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _classnames["default"])('p-3 cursor-pointer hover:bg-primary hover:text-white', {
        'font-bold': activeMode === mode
      }),
      onClick: function onClick() {
        return onSelectMode(mode);
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: modes[mode]
    }));
  }));
};

SelectionModeFooter.propTypes = {
  onSelectMode: _propTypes["default"].func,
  activeMode: _propTypes["default"].string,
  modes: _propTypes["default"].shape({})
};
SelectionModeFooter.defaultProps = {
  onSelectMode: function onSelectMode() {},
  activeMode: null,
  modes: {}
};
var _default = SelectionModeFooter;
exports["default"] = _default;